(function (exports, doc) {
    "use strict";

    exports.cookies = {
        set: function (name, value, days, domain) {
            days = days || 365;
            domain = domain || ""; 

            if (domain != "") {
                domain = ";domain =" + domain; 
            };

            var expires = "",
                date = new Date();

            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();

            doc.cookie = name + "=" + value + expires + "; path=/" + domain;
        },

        get: function (name) {
            var nameEq = name + "=",
				ca = doc.cookie.split(";");
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) === " ") {
                    c = c.substring(1, c.length);
                }
                if (c.indexOf(nameEq) === 0) {
                    return c.substring(nameEq.length, c.length);
                }
            }
            return null;
        },

        clear: function (name) {
            this.set(name, "", -1);
        }
    }
})(jQuery, document);
